(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["softcore-campaign-story"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !(event.target instanceof Element)) return;
    const disclosure = event.target.closest('.softcore-scene-product[open]');
    if (!disclosure) return;
    disclosure.open = false;
    disclosure.querySelector('summary').focus();
    event.preventDefault();
    event.stopPropagation();
  });

  } catch(e) { console.error(e); }
})();
})();
